import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from "react";
import { Flex, Box } from "sprout-ui-primitives";
import scrollIntoView from "scroll-into-view-if-needed";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import Avatar from "@sprout/client-components/dist/Avatar";
import styled from "styled-components";
import { Button } from "sprout-ui-dom/dist/Button";
import { Editor as BaseEditor, useEditorRef } from "sprout-ui-dom";
import { restoreFromLocalStorage, saveToLocalStorage } from "./utils";
const Editor = styled(BaseEditor)`
  border: 1px solid #7fc1ff;
  border-radius: 12px;

  .ProseMirror {
    font-size: 20px;
    padding: 12px 16px;
    min-height: 86px;
  }
`;
const PostPageCommentEditorDesktop = (props)=>{
    const { itemId , desktopMt , desktopMb , desktopPt , desktopVariant , comment , cacheKey , onUpdateOrCreate , onCancel ,  } = props;
    const currentUser = useCurrentUser();
    const isReply = desktopVariant === "reply";
    const { text =""  } = comment || {};
    const containerRef = useRef(null);
    useEffect(()=>{
        if (containerRef.current) scrollIntoView(containerRef.current, {
            block: "center"
        });
    }, []);
    const handleCancel = useCallback(()=>{
        saveToLocalStorage.cancel();
        onCancel();
    }, [
        onCancel
    ]);
    const handleSave = useCallback((helpers)=>{
        const { text: textToSave  } = helpers.getStateAsText(true);
        onUpdateOrCreate(textToSave);
        return true;
    }, [
        onUpdateOrCreate
    ]);
    const handleEscape = useCallback(({ blur  })=>{
        blur();
        return true;
    }, []);
    const handleChange = useCallback(({ getStateAsText  })=>{
        if (localStorage) {
            const { text: nextText  } = getStateAsText(true);
            if (!nextText) {
                localStorage.removeItem(cacheKey);
                saveToLocalStorage.cancel();
            } else saveToLocalStorage(nextText, cacheKey);
        }
    }, [
        cacheKey
    ]);
    const initialState = useRef(restoreFromLocalStorage(text, cacheKey));
    const editorRef = useEditorRef();
    const updateOrCreate = useCallback(()=>{
        if (editorRef.current) onUpdateOrCreate(editorRef.current.getStateAsText(true).text);
    }, [
        editorRef,
        onUpdateOrCreate
    ]);
    return /*#__PURE__*/ _jsxs(Flex, {
        mt: desktopMt,
        mb: desktopMb,
        pt: desktopPt,
        ref: containerRef,
        children: [
            /*#__PURE__*/ _jsx(Box, {
                flex: "none",
                mt: isReply ? undefined : 3,
                mr: "-18px",
                children: currentUser && /*#__PURE__*/ _jsx(Avatar, {
                    user: currentUser,
                    size: 36
                })
            }),
            /*#__PURE__*/ _jsxs(Box, {
                bg: isReply ? undefined : "blue.50",
                pt: isReply ? undefined : 3,
                pr: isReply ? undefined : 3,
                pb: 3,
                pl: 6,
                flex: "1",
                minWidth: "0",
                borderRadius: isReply ? undefined : "30px",
                children: [
                    /*#__PURE__*/ _jsx(Editor, {
                        itemId: itemId,
                        initialState: initialState.current,
                        autoFocus: "end",
                        mode: "SIMPLE",
                        placeholder: "Add a comment...",
                        onEscape: handleEscape,
                        onSave: handleSave,
                        onChange: handleChange,
                        ref: editorRef
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        mt: 4,
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "bright-blue",
                                onClick: updateOrCreate,
                                children: text ? "Save changes" : "Save"
                            }),
                            /*#__PURE__*/ _jsx(Box, {
                                ml: 0,
                                children: /*#__PURE__*/ _jsx(Button, {
                                    variant: "outline",
                                    onClick: handleCancel,
                                    children: "Cancel"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default PostPageCommentEditorDesktop;
